import { render, staticRenderFns } from "./ProductPatterns_comp.vue?vue&type=template&id=962c0182&scoped=true&"
import script from "./ProductPatterns_comp.vue?vue&type=script&lang=js&"
export * from "./ProductPatterns_comp.vue?vue&type=script&lang=js&"
import style0 from "./ProductPatterns_comp.vue?vue&type=style&index=0&id=962c0182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962c0182",
  null
  
)

export default component.exports